import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {ACTION_TYPES} from "../consts";
import {MenuClickEvent} from "../models/events/menu.click-event";

export class MenuClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.menuClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = MenuClickEvent
  }
}
